import {ObjectDTO} from "../object-dto";

export class UnitePmsDto extends ObjectDTO {
  libelle: string;
  abreviation: string;
}
